import { MyrAPIService } from '../api/myr/myrAPI.ts';
import { MyrAPIEndpoints } from '../api/myr/myrAPIEndpoints.constant';

export function getMemberInfo(data) {
    const { currency } = data;
    return MyrAPIService.sendRequest(MyrAPIEndpoints.SUMMARY + `/${currency || ''}`, 'GET');
}
